import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationBillableConceptsModalState, initialConfigurationBillableConceptsModalState } from '@/modules/configurationModule/detail/accounting/billable/concepts/components/modal-basic-form/concepts-modal-basic-form.model'
import { ConfigurationBillableConceptCreateRequest, ConfigurationBillableConceptPatchInBatchRequest, ConfigurationBillableConceptResponse } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.dto'
import { configurationBillableConceptService } from '@/modules/configurationModule/detail/accounting/billable/concepts/services/configuration-billable-concept.service'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { Nullable } from '@/shared/types/app.types'
import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class ConceptsModalBasicForm extends Vue {
    state: ConfigurationBillableConceptsModalState
    @Ref() readonly conceptsModal!: any
    @Prop(String) readonly actionTitle!: string

    constructor() {
        super()
        this.state = initialConfigurationBillableConceptsModalState()
    }

    async loadGroups(): Promise<void> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const filterModel = {
            'active': {
                filterType: 'boolean',
                type: 'equals',
                filter: true
            }
        }
        const response = await this.$_toCallSecure(configurationBillableConceptService.findAllConceptGroups(filterModel, params))
        if (response) {
            this.state.conceptGroups = response.content
        }
    }

    @Emit()
    create(): ConfigurationBillableConceptCreateRequest {
        return {
            name: this.state.name,
            code: this.state.code,
            active: this.state.active,
            billableConceptGroupId: this.state.group!.id
        }
    }

    @Emit()
    update(): ConfigurationBillableConceptPatchInBatchRequest {
        return {
            id: this.state.id ?? 0,
            name: this.state.name,
            code: this.state.code,
            active: this.state.active,
            billableConceptGroupId: this.state.group!.id
        }
    }

    async show(selectedRow: Nullable<ConfigurationBillableConceptResponse>): Promise<void> {
        await this.initializeConcept(selectedRow)
        this._showModal()
    }

    private _showModal(): void {
        this.conceptsModal.show()
    }

    async initializeConcept(concept: Nullable<ConfigurationBillableConceptResponse>): Promise<void> {
        this.state = initialConfigurationBillableConceptsModalState()
        await this.loadGroups()
        await this.$validator.reset()
        if (concept) {
            this.state.id = concept.id
            this.state.name = concept.name
            this.state.code = concept.code
            this.state.active = concept.active
            this.state.group = concept.group
        }
    }

    get selectedGroupCode(): string {
        return this.state.group ? this.state.group.code : ''
    }

    get updateMode(): boolean {
        return !!this.state.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update()
            } else {
                this.create()
            }
        }
    }

    hide(): void {
        this.conceptsModal.hide()
    }
}
